import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import * as Colors from 'ui-library/Colors';

const styles = StyleSheet.create({
  banner: {
    backgroundColor: Colors.BLUE_LIGHT,
    color: Colors.WHITE,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '13px 16px',
    marginBottom: '8px',
    fontSize: 13,
    lineHeight: '16px',
    borderRadius: 8,
  },
});

export interface SaveBannerProps {
  onDiscard: () => void;
  onSave: () => void;
  disableSave?: boolean;
  disableDiscard?: boolean;
  text: string;
}

function SaveBanner(props: SaveBannerProps): JSX.Element {
  return (
    <div className={css(styles.banner)} {...getTestProps({component: 'SaveBanner', element: 'root'})}>
      <div className="_test-bannerText" {...getTestProps({component: 'SaveBanner', element: 'text'})}>
        {props.text}
      </div>
      <div>
        <Button
          size={ButtonSize.MINI}
          text="Discard"
          onClick={props.onDiscard}
          buttonStyle={ButtonStyle.SECONDARY}
          disabled={props.disableDiscard}
        />
        <Button
          className="u-mini-spacing-left"
          size={ButtonSize.MINI}
          text="Save"
          onClick={props.onSave}
          buttonStyle={ButtonStyle.SECONDARY_WHITE}
          dataTestAttrs={{component: 'SaveBanner', element: 'saveButton'}}
          disabled={props.disableSave}
        />
      </div>
    </div>
  );
}

export default SaveBanner;
